import { render, staticRenderFns } from "./AssetItemPropertyLabel.vue?vue&type=template&id=5b64bbec&scoped=true&"
import script from "./AssetItemPropertyLabel.vue?vue&type=script&lang=js&"
export * from "./AssetItemPropertyLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64bbec",
  null
  
)

export default component.exports